<div class="td-wb-account-selector__container"
     (focusin)="onFocusIn()"
     (focusout)="onFocusOut($event)"
     [attr.aria-describedby]="describedbyIds()">
  <mat-select class="td-wb-account-selector__dropdown"
              #accountDropdown
              name="accountDropdown"
              [formControl]="accountFormControl"
              [attr.id]="dropdownId"
              [attr.aria-labelledby]="_formField?.getLabelId()"
              [placeholder]="placeholder">
    <mat-select-trigger class="td-wb-account-selector__mat-select-trigger">
      <ng-container [ngTemplateOutlet]="accountLabelTemplate() ?? accountLabel"
                    [ngTemplateOutletContext]="{ account: value }" />
    </mat-select-trigger>
    @for (account of accounts(); track account) {
      <mat-option [value]="account"
                  class="td-wb-account-selector__mat-option">
        <ng-container [ngTemplateOutlet]="accountLabelTemplate() ?? accountLabel"
                      [ngTemplateOutletContext]="{ account: account }" />
      </mat-option>
    }
  </mat-select>
</div>

<ng-template #accountLabel
             let-account="account">
  @if (account !== undefined && account !== null && account?.id !== '$ALL') {
    <td-wb-account-label [account]="account" />
  }
  @if (account?.id === '$ALL') {
    <div><span translate="tdWb.components.accountSelector.ALL_ACCOUNTS_PLACEHOLDER"></span></div>
  }
</ng-template>
